<template lang="pug">
  .flow-builder-show-categories-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(
          placeholder="- Agregar plataformas -",
          :options="parsedPlatforms",
          :disabled="disabled",
          :value="selected_platforms",
          @input="updatePlatforms",
          multiple,
          :limit="3",
          :searchable="false"
        )
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Comparar valores
        p.text-secondary.text-sm Te permite comparar valores y ejecuta el conector si todas o al menos una condición se cumplen.
        result-description.mb-3(variable-name="ans", variable-type="text")
        fieldset.mb-3(:disabled="disabled")
          b-form-group(
            label="Se debe cumplir:",
            v-if="template_attribute.name == 'logic_operator'",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index"
          )
            k-select.disabled-white(
              placeholder="- Seleccionar operador -",
              :options="operatorTypes",
              :disabled="disabled",
              :value="template_attribute.value || null",
              :searchable="false",
              @input="updateTemplateAttribute(template_attribute, $event)"
            )
      compare-element(v-for="(element, element_index) in Elements", :key="element.element_id", v-if="element.type == 'comparison'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", :validation-types="validationTypes", @destroy="destroyTemplateElement(element)")
      add-element-button.mb-3(v-if="!disabled", @click="createTemplateElement")
      template-connector(v-for="(connector, connector_index) in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '@/helpers/template-common'
import ResultDescription from '@/components/templates/helpers/ResultDescription.vue'
import CompareElement from '@/components/templates/CompareElement.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import Connector from '@/components/templates/connectors/Connector.vue'
import AddElementButton from '@/components/AddElementButton.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
      operatorTypes: [
        {
          label: 'Todas',
          id: 'AND'
        },
        {
          label: 'Al menos una',
          id: 'OR'
        }
      ],
      validationTypes: [
        {
          label: '=',
          id: 'equal'
        },
        {
          label: '!=',
          id: 'not_equal'
        },
        {
          label: '<',
          id: 'less_than'
        },
        {
          label: '<=',
          id: 'less_than_or_equal_to'
        },
        {
          label: '>',
          id: 'greater_than'
        },
        {
          label: '>=',
          id: 'greater_than_or_equal_to'
        },
        {
          label: 'Ω',
          id: 'matcher'
        }
      ]
    }
  },
  components: {
    'template-connector': Connector,
    ResultDescription,
    CompareElement,
    AddElementButton,
    TemplateTools
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId == `filter_by_parent_attributes_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 500, { leading: false, trailing: true })

    this.createTemplateElement = () => {
      let self = this
      let element = {
        type: 'comparison',
        number: self.Elements.length + 1,
        attributes: [
          {
            name: 'a',
            value: ''
          },
          {
            name: 'b',
            value: ''
          },
          {
            name: 'operator',
            value: 'equal'
          }
        ]
      }

      this.createElement(this.block_id, this.template_id, element)
    }

    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-show-categories-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
